import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import AddProduct from './pages/AddProduct';
import ImportProducts from './pages/ImportProducts';
import EditProduct from './pages/EditProduct';
import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import { AuthProvider } from './context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <div className="container mt-4">
            <Routes>
              <Route path="/login/:branch" element={<Login />} />
              <Route path="/:branch" element={<PrivateRoute />}>
                <Route index element={<ProductList />} />
                <Route path="products/:id" element={<ProductDetail />} />
                <Route path="add-product" element={
                  <AdminRoute>
                    <AddProduct />
                  </AdminRoute>
                } />
                <Route path="import-products" element={
                  <AdminRoute>
                    <ImportProducts />
                  </AdminRoute>
                } />
                <Route path="edit-product/:id" element={
                  <AdminRoute>
                    <EditProduct />
                  </AdminRoute>
                } />
              </Route>
              <Route path="*" element={<Navigate to="/aljumbo1" replace />} />
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
